/**
 * Odoo `crm.lead` / `artgallery.opportunity.price.history` multi-currency fields
 * (see art-gallery `crm_lead_price_history` — not product.template `Price*Ent` names).
 */

export const PIPELINE_MULTICURRENCY_CODES = [
  "AED",
  "CHF",
  "EUR",
  "GBP",
  "HKD",
  "KRW",
  "SGD",
  "USD",
] as const;

export type PipelineMulticurrencyCode = (typeof PIPELINE_MULTICURRENCY_CODES)[number];

/** `crm.lead` expected revenue per currency */
export const OPP_EXPECTED_ODOO_FIELD: Record<PipelineMulticurrencyCode, string> = {
  AED: "x_opp_expected_aed",
  CHF: "x_opp_expected_chf",
  EUR: "x_opp_expected_eur",
  GBP: "x_opp_expected_gbp",
  HKD: "x_opp_expected_hkd",
  KRW: "x_opp_expected_krw",
  SGD: "x_opp_expected_sgd",
  USD: "x_opp_expected_usd",
};

/** `artgallery.opportunity.price.history` snapshot per currency */
export const HIST_QUOTE_ODOO_FIELD: Record<PipelineMulticurrencyCode, string> = {
  AED: "x_hist_quote_aed",
  CHF: "x_hist_quote_chf",
  EUR: "x_hist_quote_eur",
  GBP: "x_hist_quote_gbp",
  HKD: "x_hist_quote_hkd",
  KRW: "x_hist_quote_krw",
  SGD: "x_hist_quote_sgd",
  USD: "x_hist_quote_usd",
};

/** Artwork list-price fields used when summing proposal totals per currency */
export const ARTWORK_ENT_FIELD: Record<PipelineMulticurrencyCode, string> = {
  AED: "PriceAEDEnt",
  CHF: "PriceCHFEnt",
  EUR: "PriceEUREnt",
  GBP: "PriceGBPEnt",
  HKD: "PriceHKDEnt",
  KRW: "PriceKRWEnt",
  SGD: "PriceSGDEnt",
  USD: "PriceUSDEnt",
};

export type OpportunityRevenueByCurrency = Record<PipelineMulticurrencyCode, number>;

export function emptyOpportunityRevenueByCurrency(): OpportunityRevenueByCurrency {
  return {
    AED: 0,
    CHF: 0,
    EUR: 0,
    GBP: 0,
    HKD: 0,
    KRW: 0,
    SGD: 0,
    USD: 0,
  };
}
